function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgStar = function SvgStar(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Star' : _ref$title,
      stroke = _ref.stroke,
      props = _objectWithoutProperties(_ref, ["title", "stroke"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 46 44"
  }), React.createElement("path", {
    d: "M23 35.37l-12.779 6.718 2.44-14.229L2.325 17.782l14.287-2.076L23 2.76l6.39 12.946 14.286 2.076-10.338 10.077 2.44 14.23L23 35.37z",
    stroke: stroke || props.color,
    strokeWidth: 2,
    fill: "#FFF",
    fillRule: "evenodd"
  }));
};

SvgStar = pure(SvgStar);
SvgStar.displayName = 'SvgStar';
export default SvgStar;